const shopify = {
  footerMessagePaymentVia: 'Pagamento via',
  inputCustomerName: 'Nome',
  inputCardExpiryDate: 'Validade do cartão',
  errorInsertCardExpiration: 'Por favor, insira a validade do cartão.',
  errorCardExpired: 'Ops! O cartão informado está vencido.',
  errorInvalidExpirationDate: 'A validade está incorreta.',
  inputCardNumber: 'Número do cartão',
  inputCardSecurityCode: 'Código de Segurança (CVV)',
  greeting: 'Olá, {customerName}',
  fillCardSecurityCode: 'Preencha o código de segurança do cartão',
  invalidSecurityCode: 'Código de segurança inválido',
  invalidCvv: 'CVV inválido',
  fillColombianAddress: 'Ei, você esqueceu de informar o seu endereço.',
  invalidColombianAddress: 'O endereço informado é inválido.',
};

module.exports = shopify;
